import type { SVGProps } from 'react';
const SvgViewStream = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_stream_svg__a)">
      <path fill="currentColor" d="M4 18h17v-6H4v6ZM4 5v6h17V5H4Z" />
    </g>
    <defs>
      <clipPath id="view_stream_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewStream;
